import { fetchWrapper } from "@/helpers/fetch-wrapper";

const API_URL = process.env.VUE_APP_SERVER_URL;

/**
 * Theo dõi một giải đấu
 * @param {string} tournamentDocumentId - ID của giải đấu cần theo dõi
 * @returns {Promise} - Kết quả từ API
 */
export async function subscribeFollow(tournamentDocumentId) {
    if (!tournamentDocumentId) {
        console.error('Tournament document ID không tồn tại');
        return;
    }

    try {
        return await fetchWrapper.post(`${API_URL}/api/follow-tournament`, {
            tournament_id: tournamentDocumentId,
        });
    } catch (error) {
        console.error('Lỗi khi theo dõi giải đấu:', error);
        throw error;
    }
}

/**
 * Hủy theo dõi một giải đấu
 * @param {string} tournamentDocumentId - ID của giải đấu cần hủy theo dõi
 * @returns {Promise} - Kết quả từ API
 */
export async function unsubscribeFollow(tournamentDocumentId) {
    if (!tournamentDocumentId) {
        console.error('Tournament document ID không tồn tại');
        return;
    }

    try {
        return await fetchWrapper.post(`${API_URL}/api/unfollow-tournament`, {
            tournament_id: tournamentDocumentId,
        });
    } catch (error) {
        console.error('Lỗi khi hủy theo dõi giải đấu:', error);
        throw error;
    }
}

/**
 * Kiểm tra xem người dùng đã theo dõi giải đấu hay chưa
 * @param {string} tournamentDocumentId - ID của giải đấu cần kiểm tra
 * @returns {Promise<boolean>} - true nếu đã theo dõi, false nếu chưa
 */
export async function checkFollowStatus(tournamentDocumentId) {
    if (!tournamentDocumentId) {
        console.error('Tournament document ID không tồn tại');
        return false;
    }

    try {
        const response = await fetchWrapper.get(`${API_URL}/api/check-follow-status/${tournamentDocumentId}`);
        return response.isFollowing || false;
    } catch (error) {
        console.error('Lỗi khi kiểm tra trạng thái theo dõi:', error);
        return false;
    }
}

export async function getFollowedTournaments() {
    try {
        const response = await fetchWrapper.get(`${API_URL}/api/followed-tournaments`);
        return response.data;
    } catch (error) {
        console.error('Lỗi khi lấy danh sách giải đấu đã theo dõi:', error);
        return [];
    }
}
